import { render, staticRenderFns } from "./stores-item.vue?vue&type=template&id=0bdc942e&scoped=true&"
import script from "./stores-item.vue?vue&type=script&lang=js&"
export * from "./stores-item.vue?vue&type=script&lang=js&"
import style0 from "./stores-item.vue?vue&type=style&index=0&id=0bdc942e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdc942e",
  null
  
)

export default component.exports